import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import  { PersonnelToWarehouseAccessView } from "./personnelToWarehouseAccess-view"

export class PersonnelToWarehouseAccessViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت دسترسی به انبارها ‌';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.personnels = ObservableArray.create<personnelToWarehouseAccess>();
        this.warehouses = ObservableArray.create<personnelToWarehouseAccess>();
        this.personnelToWarehouseAccess = ObservableArray.create<personnelToWarehouseAccess>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),150000);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new PersonnelToWarehouseAccessView();
    }
    public getTypeId(): string {
        return "VM-9E06B0F1-CE83-482A-BB11-011C4FBF0CD4"
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set warehouses(v: ObservableArray<personnelToWarehouseAccess>) { this._warehouses = v; } public get warehouses(): ObservableArray<personnelToWarehouseAccess> { return this._warehouses;} private _warehouses: ObservableArray<personnelToWarehouseAccess>;
    public set personnels(v: ObservableArray<personnelToWarehouseAccess>) { this._personnels = v; } public get personnels(): ObservableArray<personnelToWarehouseAccess> { return this._personnels;} private _personnels: ObservableArray<personnelToWarehouseAccess>;
    public set personnelToWarehouseAccess(v: ObservableArray<personnelToWarehouseAccess>) { this._personnelToWarehouseAccess = v; } public get personnelToWarehouseAccess(): ObservableArray<personnelToWarehouseAccess> { return this._personnelToWarehouseAccess;} private _personnelToWarehouseAccess: ObservableArray<personnelToWarehouseAccess>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    refresh(){
        this.loadPersonnels();
        this.loadWarehouses();
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllPersonnelToWarehouseAccess',{
                FilteringInformation:filteringInformation,
                ShowAll:false
            });
            let rowNumber = 1;
            this.personnelToWarehouseAccess.update(...result.PersonnelToWarehouseAccess.map(q=>{
                let r = new personnelToWarehouseAccess(this);
                r.id = q.Id;
                r.rowNumber = rowNumber++;
                r.creatorId = q.CreatorId;
                r.creatorName = q.CreatorName;
                r.finalizerId = q.FinalizerId;
                r.finalizerName = q.FinalizerName;
                r.warehouseId = q.WarehouseId;
                r.warehouseName = q.WarehouseName;
                r.personnelId = q.PersonnelId;
                r.personnelName = q.PersonnelName;
                r.personnelCode = q.PersonnelCode;
                r.canSale = q.CanSale;
                r.warehouseManager = q.WarehouseManager;
                r.warehouseWorker = q.WarehouseWorker;
                r.seeReports = q.SeeReports;
                r.seeBalancesInPopup = q.SeeBalancesInPopup;
                r.canConfirmUnPaidInvoice = q.CanConfirmUnPaidInvoice;
                r.warehouseKeepingConfirmer = q.WarehouseKeepingConfirmer;
                r.warehouseKeepingCounter = q.WarehouseKeepingCounter;
                r.deliveryCartableViewer = q.DeliveryCartableViewer;
                r.isUpdated = false;
                r.selected = false;
                r.hasAccess = true;
                r.from = moment.utc(q.From);
                r.until = q.Until==null? null : moment.utc(q.Until);
                r.canInvalidate = q.Until==null;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }

    async loadWarehouses(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllWarehouse',{
                NotCondition: true
            });
            this.warehouses.update(...result.Warehouse.map((q,i)=>{
                let r = new personnelToWarehouseAccess(this);
                r.rowNumber = i+1;
                r.warehouseId = q.Id;
                r.warehouseName = q.Name;
                r.selected = false;
                r.hasAccess = false;
                r.isUpdated = false;
                r.hasValue = false;
                return r;
            })); 
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async loadPersonnels(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/GetAllPersonnels',{
                ShowActive : true
            });
            this.personnels.update(...result.Personnels.map((q,i)=>{
                let r = new personnelToWarehouseAccess(this);
                r.rowNumber = i+1;
                r.personnelId = q.Id;
                r.personnelCode = q.PersonnelCode;
                r.personnelName = q.Name + ' ' + q.LastName;
                r.selected = false;
                r.hasAccess = false;
                r.isUpdated = false;
                r.hasValue = false;
                return r;
            })); 
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    selectWarehouse(warehouse: personnelToWarehouseAccess) {
        this.warehouses.forEach(x=>
        {
            x.selected = false; 
            x.hasAccess = false; 
            x.canSale = false;
            x.warehouseManager = false;
            x.warehouseWorker = false;
            x.seeReports = false;
            x.seeBalancesInPopup = false;
            x.canConfirmUnPaidInvoice = false;
            x.warehouseKeepingConfirmer = false;
            x.warehouseKeepingCounter = false;
            x.deliveryCartableViewer = false;
            x.hasValue = false;
        });
        this.personnels.forEach(x=>{
            x.selected = false; 
            x.hasAccess = false; 
            x.canSale = false;
            x.warehouseManager = false;
            x.warehouseWorker = false;
            x.seeReports = false;
            x.seeBalancesInPopup = false;
            x.canConfirmUnPaidInvoice = false;
            x.warehouseKeepingConfirmer = false;
            x.warehouseKeepingCounter = false;
            x.deliveryCartableViewer = false;
            x.hasValue = true;
        });
        warehouse.selected = true;
        let relatedAccesses = this.personnelToWarehouseAccess.filter(p => p.warehouseId == warehouse.warehouseId);
        relatedAccesses.forEach(q => {
            let relatedPersonnel = this.personnels.filter(p => p.personnelId == q.personnelId)[0];
            relatedPersonnel.canSale = q.canSale;
            relatedPersonnel.warehouseManager = q.warehouseManager;
            relatedPersonnel.warehouseWorker = q.warehouseWorker;
            relatedPersonnel.seeReports = q.seeReports;
            relatedPersonnel.seeBalancesInPopup = q.seeBalancesInPopup;
            relatedPersonnel.canConfirmUnPaidInvoice = q.canConfirmUnPaidInvoice;
            relatedPersonnel.warehouseKeepingConfirmer = q.warehouseKeepingConfirmer;
            relatedPersonnel.warehouseKeepingCounter = q.warehouseKeepingCounter;
            relatedPersonnel.deliveryCartableViewer = q.deliveryCartableViewer;
            relatedPersonnel.hasAccess = q.hasAccess;
        })
    }

    selectPersonnel(personnel: personnelToWarehouseAccess) {
        this.warehouses.forEach(x=>
        {
            x.selected = false; 
            x.hasAccess = false; 
            x.canSale = false;
            x.warehouseManager = false;
            x.warehouseWorker = false;
            x.seeReports = false;
            x.seeBalancesInPopup = false;
            x.canConfirmUnPaidInvoice = false;
            x.warehouseKeepingConfirmer = false;
            x.warehouseKeepingCounter = false;
            x.deliveryCartableViewer = false;

            x.hasValue = true;
        });
        this.personnels.forEach(x=>{
            x.selected = false; 
            x.hasAccess = false; 
            x.canSale = false;
            x.warehouseManager = false;
            x.warehouseWorker = false;
            x.seeReports = false;
            x.seeBalancesInPopup = false;
            x.canConfirmUnPaidInvoice = false;
            x.warehouseKeepingConfirmer = false;
            x.warehouseKeepingCounter = false;
            x.deliveryCartableViewer = false;

            x.hasValue = false;
        });
        personnel.selected = true;
        let relatedAccesses = this.personnelToWarehouseAccess.filter(p => p.personnelId == personnel.personnelId);
        relatedAccesses.forEach(q => {
            let relatedWarehouse = this.warehouses.filter(p => p.warehouseId == q.warehouseId)[0];
            relatedWarehouse.canSale = q.canSale;
            relatedWarehouse.warehouseManager = q.warehouseManager;
            relatedWarehouse.warehouseWorker = q.warehouseWorker;
            relatedWarehouse.seeReports = q.seeReports;
            relatedWarehouse.seeBalancesInPopup = q.seeBalancesInPopup;
            relatedWarehouse.canConfirmUnPaidInvoice = q.canConfirmUnPaidInvoice;
            relatedWarehouse.warehouseKeepingConfirmer = q.warehouseKeepingConfirmer;
            relatedWarehouse.warehouseKeepingCounter = q.warehouseKeepingCounter;
            relatedWarehouse.deliveryCartableViewer = q.deliveryCartableViewer;
            
            relatedWarehouse.hasAccess = q.hasAccess;
        })
    }

    setPersonnelUpdated(updatedPersonnel: personnelToWarehouseAccess) {
        let selectedWarehouse = this.warehouses.filter(p => p.selected)[0];
        let relatedAccess = this.personnelToWarehouseAccess.filter(p => p.personnelId == updatedPersonnel.personnelId && p.warehouseId == selectedWarehouse.warehouseId);
        if (relatedAccess.length == 0) {
            let newAccess = new personnelToWarehouseAccess(this);
            newAccess.personnelId = updatedPersonnel.personnelId;
            newAccess.warehouseId = selectedWarehouse.warehouseId;
            newAccess.canSale = updatedPersonnel.canSale;
            newAccess.warehouseManager = updatedPersonnel.warehouseManager;
            newAccess.warehouseWorker = updatedPersonnel.warehouseWorker;
            newAccess.seeReports = updatedPersonnel.seeReports;
            newAccess.seeBalancesInPopup = updatedPersonnel.seeBalancesInPopup;
            newAccess.canConfirmUnPaidInvoice = updatedPersonnel.canConfirmUnPaidInvoice;
            newAccess.warehouseKeepingConfirmer = updatedPersonnel.warehouseKeepingConfirmer;
            newAccess.warehouseKeepingCounter = updatedPersonnel.warehouseKeepingCounter;
            newAccess.deliveryCartableViewer = updatedPersonnel.deliveryCartableViewer;
            newAccess.hasAccess = updatedPersonnel.hasAccess;
            newAccess.isUpdated = true;
            relatedAccess.push(newAccess);
            this.personnelToWarehouseAccess.push(newAccess);
        }
        relatedAccess[0].canSale = updatedPersonnel.canSale;
        relatedAccess[0].warehouseManager = updatedPersonnel.warehouseManager;
        relatedAccess[0].warehouseWorker = updatedPersonnel.warehouseWorker;
        relatedAccess[0].seeReports = updatedPersonnel.seeReports;
        relatedAccess[0].seeBalancesInPopup = updatedPersonnel.seeBalancesInPopup;
        relatedAccess[0].canConfirmUnPaidInvoice = updatedPersonnel.canConfirmUnPaidInvoice;
        relatedAccess[0].warehouseKeepingConfirmer = updatedPersonnel.warehouseKeepingConfirmer;
        relatedAccess[0].warehouseKeepingCounter = updatedPersonnel.warehouseKeepingCounter;
        relatedAccess[0].deliveryCartableViewer = updatedPersonnel.deliveryCartableViewer;
        relatedAccess[0].hasAccess = updatedPersonnel.hasAccess;
        relatedAccess[0].isUpdated = true;
    }

    setWarehouseUpdated(updatedWarehouse: personnelToWarehouseAccess) {
        let selectedPersonnel = this.personnels.filter(p => p.selected)[0];
        let relatedAccess = this.personnelToWarehouseAccess.filter(p => p.warehouseId == updatedWarehouse.warehouseId && p.personnelId == selectedPersonnel.personnelId);
        if (relatedAccess.length == 0) {
            let newAccess = new personnelToWarehouseAccess(this);
            newAccess.personnelId = selectedPersonnel.personnelId;
            newAccess.warehouseId = updatedWarehouse.warehouseId;
            newAccess.canSale = updatedWarehouse.canSale;
            newAccess.warehouseManager = updatedWarehouse.warehouseManager;
            newAccess.warehouseWorker = updatedWarehouse.warehouseWorker;
            newAccess.seeReports = updatedWarehouse.seeReports;
            newAccess.seeBalancesInPopup = updatedWarehouse.seeBalancesInPopup;
            newAccess.canConfirmUnPaidInvoice = updatedWarehouse.canConfirmUnPaidInvoice;
            newAccess.warehouseKeepingConfirmer = updatedWarehouse.warehouseKeepingConfirmer;
            newAccess.warehouseKeepingCounter = updatedWarehouse.warehouseKeepingCounter;
            newAccess.deliveryCartableViewer = updatedWarehouse.deliveryCartableViewer;
            newAccess.hasAccess = updatedWarehouse.hasAccess;
            newAccess.isUpdated = true;
            relatedAccess.push(newAccess);
            this.personnelToWarehouseAccess.push(newAccess);
        }
        relatedAccess[0].canSale = updatedWarehouse.canSale;
        relatedAccess[0].warehouseManager = updatedWarehouse.warehouseManager;
        relatedAccess[0].warehouseWorker = updatedWarehouse.warehouseWorker;
        relatedAccess[0].seeReports = updatedWarehouse.seeReports;
        relatedAccess[0].seeBalancesInPopup = updatedWarehouse.seeBalancesInPopup;
        relatedAccess[0].canConfirmUnPaidInvoice = updatedWarehouse.canConfirmUnPaidInvoice;
        relatedAccess[0].warehouseKeepingConfirmer = updatedWarehouse.warehouseKeepingConfirmer;
        relatedAccess[0].warehouseKeepingCounter = updatedWarehouse.warehouseKeepingCounter;
        relatedAccess[0].deliveryCartableViewer = updatedWarehouse.deliveryCartableViewer;
        relatedAccess[0].hasAccess = updatedWarehouse.hasAccess;
        relatedAccess[0].isUpdated = true;
    }

    async save(){
        try {
            this.isLoading = true;
            let updatedAccesses = this.personnelToWarehouseAccess.filter(q => q.isUpdated);
            await ServerConnection.callServer('/Complex/WarehouseServices/CreatePersonnelToWarehouseAccess',{
                NewAccesses: updatedAccesses.map(q => {
                    return {
                        Personnel: q.personnelId,
                        Warehouse: q.warehouseId,
                        HasAccess: q.canSale || q.warehouseManager || q.warehouseWorker || q.seeReports || q.seeBalancesInPopup || q.canConfirmUnPaidInvoice || q.warehouseKeepingConfirmer || q.warehouseKeepingCounter || q.deliveryCartableViewer,
                        CanSale: q.canSale,
                        WarehouseManager: q.warehouseManager,
                        WarehouseWorker: q.warehouseWorker,
                        SeeReports: q.seeReports,
                        SeeBalancesInPopup: q.seeBalancesInPopup,
                        CanConfirmUnPaidInvoice: q.canConfirmUnPaidInvoice ?? false,
                        WarehouseKeepingConfirmer: q.warehouseKeepingConfirmer,
                        WarehouseKeepingCounter: q.warehouseKeepingCounter,
                        DeliveryCartableViewer: q.deliveryCartableViewer,
                    }
                })
            });
            await this.messageBoxConfirmSuccess('بروزرسانی دسترسی های انبار با موفقیت انجام شد','عملیات موفق');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
            this.refresh();
        }
    }
}
export class personnelToWarehouseAccess extends ViewModel{
    
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:PersonnelToWarehouseAccessViewModel) {
        super(parent);
        this._typedParent = parent;
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set personnelId(v: string) { this._personnelId = v; } public get personnelId(): string { return this._personnelId;} private _personnelId: string;
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName;} private _personnelName: string;
    public set personnelCode(v: string) { this._personnelCode = v; } public get personnelCode(): string { return this._personnelCode;} private _personnelCode: string;
    public set creatorId(v: string) { this._creatorId = v; } public get creatorId(): string { return this._creatorId;} private _creatorId: string;
    public set creatorName(v: string) { this._creatorName = v; } public get creatorName(): string { return this._creatorName;} private _creatorName: string;
    public set finalizerId(v: string) { this._finalizerId = v; } public get finalizerId(): string { return this._finalizerId;} private _finalizerId: string;
    public set finalizerName(v: string) { this._finalizerName = v; } public get finalizerName(): string { return this._finalizerName;} private _finalizerName: string;
    public set canSale(v: boolean) { this._canSale = v; } public get canSale(): boolean { return this._canSale;} private _canSale: boolean;
    public set warehouseManager(v: boolean) { this._warehouseManager = v; } public get warehouseManager(): boolean { return this._warehouseManager;} private _warehouseManager: boolean;
    public set warehouseWorker(v: boolean) { this._warehouseWorker = v; } public get warehouseWorker(): boolean { return this._warehouseWorker;} private _warehouseWorker: boolean;
    public set seeReports(v: boolean) { this._seeReports = v; } public get seeReports(): boolean { return this._seeReports;} private _seeReports: boolean;
    public set seeBalancesInPopup(v: boolean) { this._seeBalancesInPopup = v; } public get seeBalancesInPopup(): boolean { return this._seeBalancesInPopup;} private _seeBalancesInPopup: boolean;
    public set canConfirmUnPaidInvoice(v: boolean) { this._canConfirmUnPaidInvoice = v; } public get canConfirmUnPaidInvoice(): boolean { return this._canConfirmUnPaidInvoice;} private _canConfirmUnPaidInvoice: boolean;
    public set warehouseKeepingConfirmer(v: boolean) { this._warehouseKeepingConfirmer = v; } public get warehouseKeepingConfirmer(): boolean { return this._warehouseKeepingConfirmer;} private _warehouseKeepingConfirmer: boolean;
    public set warehouseKeepingCounter(v: boolean) { this._warehouseKeepingCounter = v; } public get warehouseKeepingCounter(): boolean { return this._warehouseKeepingCounter;} private _warehouseKeepingCounter: boolean;
    public set deliveryCartableViewer(v: boolean) { this._deliveryCartableViewer = v; } public get deliveryCartableViewer(): boolean { return this._deliveryCartableViewer;} private _deliveryCartableViewer: boolean;
    
    public set hasAccess(v: boolean) { this._hasAccess = v; } public get hasAccess(): boolean { return this._hasAccess;} private _hasAccess: boolean;
    public set hasValue(v: boolean) { this._hasValue = v; } public get hasValue(): boolean { return this._hasValue;} private _hasValue: boolean;
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set canInvalidate(v: boolean) { this._canInvalidate = v; } public get canInvalidate(): boolean { return this._canInvalidate;} private _canInvalidate: boolean;
    public set selected(v: boolean) { this._selected = v; } public get selected(): boolean { return this._selected;} private _selected: boolean;
    public set isUpdated(v: boolean) { this._isUpdated = v; } public get isUpdated(): boolean { return this._isUpdated;} private _isUpdated: boolean;
    
    private _typedParent:PersonnelToWarehouseAccessViewModel;

    async selectWarehouse() {
        this._typedParent.selectWarehouse(this);
    }

    async selectPersonnel() {

        this._typedParent.selectPersonnel(this);
    }

    setWarehouseUpdated() {
        this._typedParent.setWarehouseUpdated(this);
    }

    setPersonnelUpdated() {
        this._typedParent.setPersonnelUpdated(this);
    }

}
